import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { StorageService } from '../services/storage.service';
import { AuthenticationService } from '../services/security/authentication.service';
import { RestService } from '../services/rest.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';


@Component({
  selector: 'exception',
  providers: [StorageService, RestService, AuthenticationService],
  templateUrl: './exception.component.html',
  styleUrls: ['./exception.component.scss']
})
export class ExceptionComponent implements AfterViewInit, OnInit {

  exceptions: any[];
  exceptionsResolved: any[];
  filteredExceptions: any[];
  filterTitle: string;
  filterString: string = '';
  storage: string;
  selectedExceptionCodes: string[] = [];
  private exceptionLoadVersion: number = 0;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _restService: RestService,
    private _authenticationService: AuthenticationService,
    private _router: Router,
    private _dialogService: TdDialogService,
    private _snackBarService: MdSnackBar,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService) {
  }

  ngOnInit(): void {
    this._titleService.setTitle('Exception manager');
    this.filterTitle = 'Resolved exceptions';
    this.storage = this._authenticationService.getStorageName().toLowerCase();
    this.loadFilter(this.filterTitle);
  }

  loadFilter(filterTitle: string) {
    this.filterTitle = filterTitle;
    this.load(filterTitle);
  }

  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  }

  filterExceptions(value: string = ''): void {
    this.filterString = value;
      this.filteredExceptions = this.exceptions.filter((exception: any) => {
          return (this.filterString == '') ||
                ((   exception.exceptionType.toLowerCase().indexOf(value.toLowerCase()) > -1 
                    || (exception.reference && exception.reference.toLowerCase().indexOf(value.toLowerCase()) > -1)
                    || exception.exceptionStatus.toLowerCase().indexOf(value.toLowerCase()) > -1
                    || exception.code.toLowerCase().indexOf(value.toLowerCase()) > -1
                    || (exception.containerName && exception.containerName.toLowerCase().indexOf(value.toLowerCase()) > -1)));
      });
  }


  async load(filter: string): Promise<void> {
    let loadVersion = ++this.exceptionLoadVersion;
    try {
      this._loadingService.register('exceptionList.list');
      await this.doLoad(filter, loadVersion);
    } catch (error) {
      
    } finally {
      if (this.isCurrentExceptionLoad(loadVersion)) {
        this.filteredExceptions = Object.assign([], this.exceptions);
      }
      this._loadingService.resolve('exceptionList.list');
    }
  }

  private async doLoad(filter: string, loadVersion: number): Promise<any> {
    this.exceptions = [];
    if (filter == 'All exceptions') {

      if (this.storage.indexOf('ch_bsf') > -1) {
        this.exceptions =  await this._storageService.getExceptions('OPEN').toPromise();
      } else {
        this.exceptions =  await this._storageService.getExceptions('PENDING').toPromise();
      }
    
    } else if (filter == 'Resolved exceptions' && this.storage.indexOf('de_bsa') > -1) { // not show resolved exceptions for ch_bsf
      
      this.exceptionsResolved = await this._storageService.getResolvedExceptions('NOT_FOUND').toPromise();
      if (!this.isCurrentExceptionLoad(loadVersion)) {
        return;
      }

      this.exceptions = Object.assign([], this.exceptionsResolved);
      this.filteredExceptions = Object.assign([], this.exceptions);
      this.loadResolvedNotFoundExceptionCustomers(loadVersion).catch((error) => {});

    }     
      
  }

  private async loadResolvedNotFoundExceptionCustomers(loadVersion: number): Promise<void> {
    if (!this.exceptionsResolved || this.exceptionsResolved.length == 0) {
      return;
    }

    let trackingNumbers: string[] = [];
    let trackingNumberKeys: any = {};
    for (let exception of this.exceptionsResolved) {
      if (exception.code && !trackingNumberKeys[exception.code]) {
        trackingNumberKeys[exception.code] = true;
        trackingNumbers.push(exception.code);
      }
    }

    if (trackingNumbers.length == 0) {
      this.exceptions = Object.assign([], this.exceptionsResolved);
      return;
    }

    let trackingItems: any[] = [];
    for (let trackingNumberBatch of this.getBatches(trackingNumbers, 200)) {
      let trackingItemsBatch = await this._restService.getTrackingsByTrackingNumbers(trackingNumberBatch).toPromise() || [];
      if (!this.isCurrentExceptionLoad(loadVersion)) {
        return;
      }
      trackingItems = trackingItems.concat(trackingItemsBatch);
    }

    let trackingByNumber: any = {};
    let orderReferences: any[] = [];
    let orderReferenceKeys: any = {};

    for (let trackingItem of trackingItems) {
      if (!trackingItem || !trackingItem.trackingNumber || !trackingItem.reference || trackingItem.projectId == null) {
        continue;
      }

      trackingByNumber[trackingItem.trackingNumber] = trackingItem;

      let key = this.getOrderReferenceKey(trackingItem.reference, trackingItem.projectId);
      if (!orderReferenceKeys[key]) {
        orderReferenceKeys[key] = true;
        orderReferences.push({
          reference: trackingItem.reference,
          projectId: trackingItem.projectId
        });
      }
    }

    let orderCustomersByReference: any = {};
    let orderCustomersByTrackingNumber: any = {};

    if (orderReferences.length > 0) {
      let orderCustomers: any[] = [];
      for (let orderReferenceBatch of this.getBatches(orderReferences, 200)) {
        let orderCustomersBatch = await this._restService.getOrderCustomersByReferences(orderReferenceBatch).toPromise() || [];
        if (!this.isCurrentExceptionLoad(loadVersion)) {
          return;
        }
        orderCustomers = orderCustomers.concat(orderCustomersBatch);
      }

      for (let orderCustomer of orderCustomers) {
        if (!orderCustomer) {
          continue;
        }

        if (orderCustomer.trackingNumber) {
          orderCustomersByTrackingNumber[orderCustomer.trackingNumber] = orderCustomer;
        }

        if (orderCustomer.reference && orderCustomer.projectId != null) {
          orderCustomersByReference[this.getOrderReferenceKey(orderCustomer.reference, orderCustomer.projectId)] = orderCustomer;
        }
      }
    }

    for (let exception of this.exceptionsResolved) {
      if (!this.isCurrentExceptionLoad(loadVersion)) {
        return;
      }

      let trackingItem = trackingByNumber[exception.code];
      if (trackingItem) {
        let orderCustomer = orderCustomersByTrackingNumber[exception.code] ||
          orderCustomersByReference[this.getOrderReferenceKey(trackingItem.reference, trackingItem.projectId)];

        if (orderCustomer) {
          exception.customerName = orderCustomer.customerName || orderCustomer.customerNumber;
        }
      }
    }

    this.filteredExceptions = Object.assign([], this.exceptions);
  }

  private getOrderReferenceKey(reference: string, projectId: any): string {
    return reference + '|' + projectId;
  }

  private getBatches(items: any[], batchSize: number): any[] {
    let batches: any[] = [];
    for (let index = 0; index < items.length; index += batchSize) {
      batches.push(items.slice(index, index + batchSize));
    }
    return batches;
  }

  private isCurrentExceptionLoad(loadVersion: number): boolean {
    return loadVersion == this.exceptionLoadVersion;
  }

  resolveException(exception: any): void {
    this._dialogService
      .openConfirm({message: 'Are you sure you want to resolve this exception?'})
      .afterClosed().toPromise().then((confirm: boolean) => {
        if (confirm) {
          this._resolveException(exception.code);
        }
      });
  }

  private async _resolveException(code: string): Promise<void> {
    try {
      this._loadingService.register('exceptionList.list');
      await this._storageService.resolveException(code, null).toPromise();
      this._snackBarService.open('Exception resolved', 'Ok');
      this.load(this.filterTitle);
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error trying to resolve the exception'});
    } finally {
      this._loadingService.resolve('exceptionList.list');
    }
  }

  deleteException(exception: any): void {
    this._dialogService
      .openConfirm({message: 'Are you sure you want to delete this exception?'})
      .afterClosed().toPromise().then((confirm: boolean) => {
        if (confirm) {
          this._deleteException(exception.code);
        }
      });
  }

  private async _deleteException(code: string): Promise<void> {
    try {
      this._loadingService.register('exceptionList.list');
      let exception = await this._storageService.getException(code).toPromise();
      exception.exceptionStatus = 'DELETED';
      await this._storageService.resolveException(exception.code, "DELETED").toPromise();
      this._snackBarService.open('Exception deleted', 'Ok');
      this.load(this.filterTitle);
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error trying to delete the exception'});
    } finally {
      this._loadingService.resolve('exceptionList.list');
    }
  }

  deleteExceptions(exceptions: any[]): void {
    if (!exceptions || exceptions.length === 0) {
      return;
    }

    this._dialogService
      .openConfirm({message: 'Are you sure you want to delete ' + exceptions.length + ' selected exception(s)?'})
      .afterClosed().toPromise().then((confirm: boolean) => {
        if (confirm) {
          this._deleteExceptions(exceptions);
        }
      });
  }

  private async _deleteExceptions(exceptions: any[]): Promise<void> {
    try {
      this._loadingService.register('exceptionList.list');

      let exceptionCodes: string[] = [];
      for (let selectedException of exceptions) {
        exceptionCodes.push(selectedException.code);
      }

      let exceptionList = await this._storageService.getExceptionsByCodes(exceptionCodes).toPromise();
      let exceptionCodeRequests: any[] = [];

      for (let exception of exceptionList) {
        exceptionCodeRequests.push({
          code: exception.code,
          reference: exception.reference,
          exceptionStatus: 'DELETED'
        });
      }

      await this._storageService.resolveExceptionsBulk(exceptionCodeRequests).toPromise();

      this._snackBarService.open(exceptions.length + ' exception(s) deleted', 'Ok');
      this.clearSelectedExceptions();
      this.load(this.filterTitle);
    } catch (error) {
      this._dialogService.openAlert({message: 'There was an error trying to delete the selected exceptions'});
    } finally {
      this._loadingService.resolve('exceptionList.list');
    }
  }

  toggleExceptionSelection(exception: any): void {
    if (!this.canDeleteException(exception)) {
      return;
    }

    let selectedIndex = this.selectedExceptionCodes.indexOf(exception.code);
    if (selectedIndex > -1) {
      this.selectedExceptionCodes.splice(selectedIndex, 1);
    } else {
      this.selectedExceptionCodes.push(exception.code);
    }
  }

  selectAllExceptions(checked: boolean): void {
    this.selectedExceptionCodes = [];

    if (checked) {
      for (let exception of this.getVisibleDeletableExceptions()) {
        this.selectedExceptionCodes.push(exception.code);
      }
    }
  }

  isExceptionSelected(exception: any): boolean {
    return exception && this.selectedExceptionCodes.indexOf(exception.code) > -1;
  }

  hasSelectedExceptions(): boolean {
    return this.getSelectedExceptions().length > 0;
  }

  areAllVisibleExceptionsSelected(): boolean {
    let exceptions = this.getVisibleDeletableExceptions();
    return exceptions.length > 0 && exceptions.length === this.getSelectedExceptions().length;
  }

  areSomeVisibleExceptionsSelected(): boolean {
    return this.getSelectedExceptions().length > 0 && !this.areAllVisibleExceptionsSelected();
  }

  getSelectedExceptions(): any[] {
    let exceptions: any[] = [];

    for (let exception of this.getVisibleDeletableExceptions()) {
      if (this.isExceptionSelected(exception)) {
        exceptions.push(exception);
      }
    }

    return exceptions;
  }

  canDeleteException(exception: any): boolean {
    return exception && exception.exceptionStatus != 'RESOLVED';
  }

  showBulkDeleteControls(): boolean {
    return this.filterTitle == 'All exceptions';
  }

  private clearSelectedExceptions(): void {
    this.selectedExceptionCodes = [];
  }

  private getVisibleDeletableExceptions(): any[] {
    let exceptions: any[] = [];

    if (!this.showBulkDeleteControls() || !this.filteredExceptions) {
      return exceptions;
    }

    for (let i = 0; i < this.filteredExceptions.length && i < 200; i++) {
      if (this.canDeleteException(this.filteredExceptions[i])) {
        exceptions.push(this.filteredExceptions[i]);
      }
    }

    return exceptions;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/exception/exception.component.ts